module.exports = __webpack_public_path__ + "static/media/1 42 hos.f9f679a3.mp3";